module.exports = __webpack_public_path__ + "img/pizza_chorizo_done_2.6640d3ec.jpg";